// src/pages/Catalogo.jsx
import React, { useEffect, useState, useCallback } from 'react';
import { motion } from 'framer-motion';
import { BookOpen, ExternalLink, Maximize2, RefreshCw, ChevronDown } from 'lucide-react';
import { useQuery } from '../QueryContext';
import './Catalogo.css';

const Catalogo = () => {
  const { getCatalogoConfig } = useQuery();
  const [catalogos, setCatalogos] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const cargarConfig = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await getCatalogoConfig();
      if (Array.isArray(data) && data.length > 0) {
        setCatalogos(data);
        if (!selectedId) setSelectedId(data[0].id);
      } else {
        setError('No se recibieron catálogos válidos desde el servidor.');
      }
    } catch {
      setError('No se pudo cargar la configuración de los catálogos.');
    } finally {
      setLoading(false);
    }
  }, [getCatalogoConfig, selectedId]);

  useEffect(() => {
    cargarConfig();
  }, [cargarConfig]);

  const catalogoActual = catalogos.find(c => c.id === selectedId);

  const abrirEnDrive = () => {
    if (catalogoActual?.file_id) {
      window.open(`https://drive.google.com/file/d/${catalogoActual.file_id}/view`, '_blank');
    }
  };

  const pantallaCompleta = () => {
    const el = document.querySelector('.catalogo-viewer');
    if (!el) return;
    if (el.requestFullscreen) el.requestFullscreen();
    else if (el.webkitRequestFullscreen) el.webkitRequestFullscreen();
  };

  const seleccionarCatalogo = (id) => {
    setSelectedId(id);
    setDropdownOpen(false);
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
      className="catalogo-page"
    >
      <header className="catalogo-header">
        <div className="catalogo-header-left">
          <div className="catalogo-header-icon">
            <BookOpen size={22} />
          </div>
          <div className="catalogo-header-titles">
            <h1>Catálogos</h1>
            <p>Visor interactivo</p>
          </div>
        </div>

        <div className="catalogo-actions">
          {/* Selector de catálogo */}
          {catalogos.length > 1 && (
            <div className="catalogo-selector">
              <button
                className="catalogo-btn ghost"
                onClick={() => setDropdownOpen(o => !o)}
              >
                <span className="btn-label">
                  {catalogoActual?.title || 'Seleccionar'}
                </span>
                <ChevronDown size={16} />
              </button>

              {dropdownOpen && (
                <div className="catalogo-dropdown">
                  {catalogos.map(cat => (
                    <button
                      key={cat.id}
                      className={`catalogo-dropdown-item ${cat.id === selectedId ? 'active' : ''}`}
                      onClick={() => seleccionarCatalogo(cat.id)}
                    >
                      {cat.title}
                    </button>
                  ))}
                </div>
              )}
            </div>
          )}

          <button
            className="catalogo-btn ghost"
            onClick={cargarConfig}
            title="Recargar"
          >
            <RefreshCw size={16} />
            <span className="btn-label">Recargar</span>
          </button>

          <button
            className="catalogo-btn ghost"
            onClick={pantallaCompleta}
            title="Pantalla completa"
          >
            <Maximize2 size={16} />
            <span className="btn-label">Pantalla completa</span>
          </button>

          <button
            className="catalogo-btn primary"
            onClick={abrirEnDrive}
            title="Abrir en Drive"
          >
            <ExternalLink size={16} />
            <span className="btn-label">Abrir en Drive</span>
          </button>
        </div>
      </header>

      <div className="catalogo-viewer">
        {loading && (
          <div className="catalogo-status">
            <div className="catalogo-spinner" />
            <span>Cargando catálogos…</span>
          </div>
        )}

        {!loading && error && (
          <div className="catalogo-status error">
            <span>{error}</span>
          </div>
        )}

        {!loading && !error && catalogoActual?.embed_url && (
          <iframe
            src={catalogoActual.embed_url}
            title={catalogoActual.title}
            allow="autoplay"
            loading="lazy"
          />
        )}
      </div>
    </motion.div>
  );
};

export default Catalogo;